import React from "react";
import { Tooltip as AntTooltip } from "antd";

const Tooltip = (props) => (
  <AntTooltip title={props.title}>{props.children}</AntTooltip>
);

export default Tooltip;
